import { LEGAL_MENTIONS_URL } from "@/constants/external-links";
import { ROUTE } from "@/constants/routes";
import { Link } from "react-router";

const Footer = () => {
  return (
    <footer className="flex items-center justify-center gap-4 py-4 px-20 bg-white border-t border-gray-200">
      <Link
        to={ROUTE.candidate.dashboard.cgu()}
        className="text-sm text-gray-600 hover:text-gray-800 transition-colors duration-200"
      >
        Conditions Générales d'Utilisation
      </Link>
      <span className="text-gray-400">|</span>
      <Link
        to={ROUTE.candidate.dashboard.cgv()}
        className="text-sm text-gray-600 hover:text-gray-800 transition-colors duration-200"
      >
        Conditions Générales de Vente
      </Link>
      <span className="text-gray-400">|</span>
      <Link
        to={LEGAL_MENTIONS_URL}
        className="text-sm text-gray-600 hover:text-gray-800 transition-colors duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        Mentions légales
      </Link>
    </footer>
  );
};

export default Footer;
